import { createFileRoute } from '@tanstack/react-router'

import { buildPageTitle } from '@/shared/lib/page-title'
import { MyDataPage } from '@/features/account-data'

export const Route = createFileRoute('/_authenticated/_main/meus-dados/')({
  head: () => ({
    meta: [{ title: buildPageTitle('Meus Dados') }]
  }),
  component: MyDataPage
})
